import { render, staticRenderFns } from "./node-area-wrap.vue?vue&type=template&id=9db37764"
import script from "./node-area-wrap.vue?vue&type=script&lang=js"
export * from "./node-area-wrap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports